import { http } from '../../config/axios'

export default function getTipoResultadoMotorCredito(): Promise<any> {
  return http
    .get('api/resultadomotorcredito/tiposresultado/')
    .then((res) => {
      return res.data as any
    })
    .catch((error) => {
      console.error('Erro getTipoResultadoMotorCredito', error)
      throw Error(error.response.data)
    })
}
